<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo" :to="{name : 'login'}">
        <b-img :src="appLogoImage" :alt="'Logo ' + appName" width="40" height="40"/>
        <h2 class="brand-text text-primary m-auto pl-1">{{ appName }}</h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img fluid :src="imgUrl" alt="Register V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Register-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1"> {{ $t('Adventure starts here 🚀') }} </b-card-title>
          <b-card-text class="mb-2"> {{ $t('Make your app management easy and fun!') }} </b-card-text>

          <!-- form -->
          <validation-observer ref="registerForm" #default="{ invalid }">
            <b-form class="register-form mt-2" @submit.prevent="register">

              <!-- name -->
              <b-form-group :label="$t('Name')" label-for="register-name">
                <validation-provider #default="{ errors }" :name="$t('name')" vid="name" rules="required" >
                  <b-form-input id="register-name" v-model="name" name="register-name" :state="errors.length > 0 ? false : null" placeholder="" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- surname -->
              <b-form-group :label="$t('Surname')" label-for="register-surname">
                <validation-provider #default="{ errors }" :name="$t('surname')" vid="surname" rules="required" >
                  <b-form-input id="register-surname" v-model="surname" name="register-surname" :state="errors.length > 0 ? false : null" placeholder="" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>


              <!-- username -->
              <b-form-group :label="$t('Username')" label-for="register-username">
                <validation-provider #default="{ errors }" :name="$t('username')" vid="username" rules="required" >
                  <b-form-input id="register-username" v-model="username" name="register-username" :state="errors.length > 0 ? false : null" placeholder="" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- email -->
              <b-form-group :label="$t('Email')" label-for="register-email">
                <validation-provider #default="{ errors }" :name="$t('email')" vid="email" rules="required|email" >
                  <b-form-input id="register-email" v-model="userEmail" name="register-email" :state="errors.length > 0 ? false : null" placeholder="" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group label-for="register-password" :label="$t('Password')">
                <validation-provider #default="{ errors }" :name="$t('password')" vid="password" rules="required" >
                  <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null" >
                    <b-form-input id="register-password" v-model="password" class="form-control-merge" :type="passwordFieldType" :state="errors.length > 0 ? false : null" name="register-password" placeholder="············" />
                    <b-input-group-append is-text>
                      <feather-icon :icon="passwordToggleIcon" class="cursor-pointer" @click="togglePasswordVisibility" />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group>
                <b-form-checkbox id="register-privacy-policy" v-model="status" name="checkbox-1" required > {{ $t('I agree to') }} <b-link :to="{name : 'privacy'}">{{ $t('privacy policy & terms') }}</b-link> </b-form-checkbox>
              </b-form-group>

              <b-button variant="primary" block type="submit" :disabled="invalid" > {{ $t('Sign up') }} </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2"> <span>{{ $t("Already have an account?") }}</span> <b-link :to="{ name: 'login' }"> <span>&nbsp; {{ $t('Sign in instead') }}</span> </b-link> </p>

        </b-col>
      </b-col>
      <!-- /Register-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { BRow, BCol, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BImg, BCardTitle, BCardText, } from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from "@/store/index";
import useJwt from "@/auth/jwt/useJwt";
import { $themeConfig } from '@themeConfig';
import i18n from "@/libs/i18n";

export default {
  components: { BRow, BImg, BCol, BLink, BButton, BForm, BCardText, BCardTitle, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      username: "",
      name: "",
      surname: "",
      userEmail: "",
      password: "",
      sideImg: require("@/assets/images/pages/register.svg"),
      // validation
      required,
      email,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        this.sideImg = require("@/assets/images/pages/register-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    register() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          useJwt.register({
            name: this.name,
            surname: this.surname,
            username: this.username,
            email: this.userEmail,
            password: this.password,
            c_password: this.password,

            locale: localStorage.getItem('locale')
          })
            .then(response => {
              this.$router.replace({ name: 'login' }).then(() => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: i18n.t('A verification email has been sent'),
                    icon: 'MailIcon',
                    variant: 'success',
                  },
                })
              })
            })
            .catch(error => {
              this.$refs.registerForm.setErrors(error.response.data.error)
            })
        }
      })
    },
  },
  setup(){
    const { appName, appLogoImage } = $themeConfig.app
    return { appName, appLogoImage, }
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@core/scss/vue/pages/page-auth.scss";
</style>
